import React, { useState, ChangeEvent } from 'react';

function QRGenerator() {
    const [input, setInput] = useState('');
    const [qrImage, setQrImage] = useState('');
    const [size, setSize] = useState<'small' | 'medium' | 'large'>('medium');

    const sizes = {
        small: '150',
        medium: '300',
        large: '450'
    };

    const generateQR = () => {
        if (!input.trim()) return;
        
        const baseUrl = 'https://api.qrserver.com/v1/create-qr-code/';
        const params = new URLSearchParams({
            data: input,
            size: `${sizes[size]}x${sizes[size]}`,
            format: 'svg'
        });
        
        setQrImage(`${baseUrl}?${params.toString()}`);
    };

    const handleDownload = (format: 'jpg' | 'png' | 'svg') => {
        if (!qrImage) return;

        const baseUrl = 'https://api.qrserver.com/v1/create-qr-code/';
        const params = new URLSearchParams({
            data: input,
            size: `${sizes[size]}x${sizes[size]}`,
            format: format
        });
        
        const downloadUrl = `${baseUrl}?${params.toString()}`;

        fetch(downloadUrl)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `qr-code-${size}.${format}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            generateQR();
        }
    };

    return (
        <div className="tool">
            <h2>QR Code Generator</h2>
            <div className="content">
                <div className="qr-generator">
                    <div className="qr-generator__input-section">
                        <div className="qr-generator__input-type">
                            <div className="qr-generator__type-selector">
                                <button
                                    className={`qr-generator__type-button ${size === 'small' ? 'active' : ''}`}
                                    onClick={() => setSize('small')}
                                >
                                    Small
                                </button>
                                <button
                                    className={`qr-generator__type-button ${size === 'medium' ? 'active' : ''}`}
                                    onClick={() => setSize('medium')}
                                >
                                    Medium
                                </button>
                                <button
                                    className={`qr-generator__type-button ${size === 'large' ? 'active' : ''}`}
                                    onClick={() => setSize('large')}
                                >
                                    Large
                                </button>
                            </div>
                        </div>

                        <div className="qr-generator__input-container">
                            <input
                                type="text"
                                value={input}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setInput(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder="Enter text or URL to generate QR code..."
                                className="qr-generator__input"
                            />
                            <button 
                                onClick={() => setInput('')}
                                className="qr-generator__clear-button"
                            >
                                Clear
                            </button>
                        </div>

                        <button 
                            onClick={generateQR}
                            className="qr-generator__convert-button"
                        >
                            Generate QR
                        </button>
                    </div>

                    <div className="qr-generator__results">
                        {qrImage && (
                            <div className="qr-generator__qr-container">
                                <img 
                                    src={qrImage} 
                                    alt="Generated QR Code" 
                                    className="qr-generator__qr-image"
                                />
                                <div className="qr-generator__download-buttons">
                                    <button
                                        onClick={() => handleDownload('jpg')}
                                        className="qr-generator__download-button qr-generator__download-button--jpg"
                                    >
                                        Download JPG
                                    </button>
                                    <button
                                        onClick={() => handleDownload('png')}
                                        className="qr-generator__download-button qr-generator__download-button--png"
                                    >
                                        Download PNG
                                    </button>
                                    <button
                                        onClick={() => handleDownload('svg')}
                                        className="qr-generator__download-button qr-generator__download-button--svg"
                                    >
                                        Download SVG
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QRGenerator; 